import { API_ENDPOINTS } from 'data';
import client from './axiosClient';
import { Document } from 'data/models';

export const getUserDocuments = async (docType: string) => {
  return client.get(`${API_ENDPOINTS.USER_DOCUMENTS.GET}?docType=${docType}`);
};

export const downloadInvoiceDoc = async (invoiceId: number, docType: string) => {
	return client.get(`invoices/${invoiceId}/${API_ENDPOINTS.INVOICE_DOCUMENTS.DOWNLOAD}?docType=${docType}`);
};

export const downloadUserDoc = async (docId: number, docType: string) => {
	return client.get(`${API_ENDPOINTS.USER_DOCUMENTS.GET}/${docId}/download?docType=${docType}`);
};

export const createUserDocument = async (formData: FormData, docType: string) => {
  return client.post(`${API_ENDPOINTS.USER_DOCUMENTS.CREATE}?docType=${docType}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export const deleteUserDocument = async (documentId: number) => {
  return client.delete(`${API_ENDPOINTS.USER_DOCUMENTS.DELETE}/${documentId}`);
};

export const findUserDocs = async (docType: string): Promise<Document[]> => {
	try {
		const response = await client.get<Document[]>(`${API_ENDPOINTS.USER_DOCUMENTS.GET}?docType=${docType}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching user documents:', error);
		throw error;
	}
};

export const uploadInvoiceDocs = async (formData: FormData, invoiceId: number) => {
	return client.post(`${API_ENDPOINTS.INVOICE_DOCUMENTS.CREATE}/${invoiceId}`, formData, {
		headers: {
		  'Content-Type': 'multipart/form-data',
		},
	  },
	);
};

export const findInvoiceDocs = async (invoiceId: number): Promise<Document[]> => {
	try {
		const response = await client.get<Document[]>(`${API_ENDPOINTS.INVOICE_DOCUMENTS.GET}/${invoiceId}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching invoice documents:', error);
		throw error;
	}
};

export const deleteInvoiceDoc = async (docId: number) => {
	return client.delete(`${API_ENDPOINTS.INVOICE_DOCUMENTS.DELETE}/${docId}`);
};